
export default {
    props: {
        error: { type: String, default: null },
        nextLabel: { type: String, default: 'Continue' },
        hideBack: { type: Boolean, default: false },
        hideNext: { type: Boolean, default: false },
        showSaveLater: { type: Boolean, default: true },
    },
}
